module.exports = "/_next/static/images/cu-89e88662230b6d09130b18c77cbf2659.svg";